import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import DataTable from "../../shared/component/dataTable/DataTable";
import PurchaseOrderColumn from "../../shared/component/dataTable/columns/PurchaseOrderColumn.json";
import PurchaseOrderMobileColumn from "../../shared/component/dataTable/columns/PurchaseOrderMobileColumn.json";
import PurchaseRequisitionAssignDnColumn from "../../shared/component/dataTable/columns/PurchaseRequisitionAssignDnColumn.json";
import {Button, Col, Row} from "reactstrap";
import Translate from "../../shared/language/Translate";
import {toast} from "react-toastify";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import LicenseService from "../../shared/service/LicenseService";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import {PURCHASE_ORDER_STATUS} from "../../shared/utils/Constants";
import {Calendar} from "primereact/calendar";
import {TabPanel, TabView} from 'primereact/tabview';
import Dialog from '../../shared/component/dialog/Dialog';
import dayjs from 'dayjs';
import '../../shared/styles/SettingsPage.css';
import PurchaseRequisitionNavShortcuts from '../purchaserequisition/PurchaseRequisitionNavShortcuts';

const LIST_FILTER_STORAGE_KEY = 'purchaseOrder.listFilter';
const OPEN_DETAIL_PAYMENTS_TAB_KEY = 'purchaseOrder.openDetailPaymentsTab';
const LICENSE_CREDIT_MESSAGE = "You don't have an invoice license or your credit has run out.";

const INVOICE_FROM_DN_FIELDS = PurchaseRequisitionAssignDnColumn.fields.map(field => {
    if (field.field === 'checkoutDate') {
        return {...field, header: 'Approved Date'};
    }
    return field;
}).concat([{
    field: 'description',
    header: 'Supplier',
    visible: true,
    filter: true,
    sortable: false,
    style: {width: '28%', minWidth: '8rem', textAlign: 'left'},
    headerStyle: {textAlign: 'center'}
}]);

function loadStoredListFilter() {
    try {
        const raw = sessionStorage.getItem(LIST_FILTER_STORAGE_KEY);
        if (!raw) {
            return {purchaseOrderStatus: 'INVOICE', activeTabIndex: 0};
        }
        const parsed = JSON.parse(raw);
        const statusValues = PURCHASE_ORDER_STATUS.map(item => item.value);
        const purchaseOrderStatus = statusValues.includes(parsed?.purchaseOrderStatus)
            ? parsed.purchaseOrderStatus
            : 'INVOICE';
        const activeTabIndex = parsed?.activeTabIndex === 1 ? 1 : 0;
        return {purchaseOrderStatus, activeTabIndex};
    } catch (e) {
        return {purchaseOrderStatus: 'INVOICE', activeTabIndex: 0};
    }
}

function saveStoredListFilter(purchaseOrderStatus, activeTabIndex) {
    try {
        sessionStorage.setItem(LIST_FILTER_STORAGE_KEY, JSON.stringify({
            purchaseOrderStatus,
            activeTabIndex: activeTabIndex === 1 ? 1 : 0
        }));
    } catch (e) {
        // ignore storage errors
    }
}

function setOpenDetailPaymentsTab(enabled) {
    try {
        if (enabled) {
            sessionStorage.setItem(OPEN_DETAIL_PAYMENTS_TAB_KEY, '1');
        } else {
            sessionStorage.removeItem(OPEN_DETAIL_PAYMENTS_TAB_KEY);
        }
    } catch (e) {
        // ignore
    }
}

export default class PurchaseOrder extends React.Component {
    constructor(props) {
        super(props);
        const stored = loadStoredListFilter();
        this.state = {
            hasInvoiceLicense: false,
            purchaseOrderStatus: stored.purchaseOrderStatus,
            id: "",
            activeTabIndex: stored.activeTabIndex,
            calendarMonth: new Date(),
            selectedCalendarDay: new Date(),
            paymentDues: [],
            paymentDuesLoading: false,
            displayCreateFromDnDialog: false,
            createFromDnList: [],
            createFromDnLoading: false,
            selectedDeliveryNoteId: null,
            creatingFromDn: false
        }
        this.licenseService = new LicenseService();
        this.purchaseOrderService = new PurchaseOrderService();
    }

    componentDidMount() {
        this.licenseService.getLicenses(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                if (response.hasInvoiceLicense == true && response.remainingCredit != null && response.remainingCredit > 0) {
                    this.setState({
                        hasInvoiceLicense: true
                    }, () => {
                        if (this.state.activeTabIndex === 1) {
                            this.loadPaymentDuesForMonth();
                        } else {
                            this.refreshDataTable();
                        }
                    });

                } else {
                    return toast.warn("You don't have an invoice license or your credit has run out.");
                }
            } else {
                return toast.warn("You don't have an invoice license or your credit has run out.");

            }
        });

        // 10 saniyede bir refresh (mevcut filtre/sorting korunur)
        this.refreshInterval = setInterval(() => {
            this.refreshDataTableSilent();
        }, 1000 * 10); // 10000ms = 10s
    }

    componentWillUnmount() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }



    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header settings-page__header--with-shortcuts">
                            <h1 className="settings-page__title">Invoice</h1>
                            <PurchaseRequisitionNavShortcuts activeId="invoice"/>
                        </div>
                        {this.purchaseOrderList()}
                    </div>
                </AvForm>
            </div>
        );
    }

    purchaseOrderList() {
        return (
            <div className="settings-page__panel">
                <TabView
                    className="settings-page__tabs"
                    activeIndex={this.state.activeTabIndex || 0}
                    onTabChange={(e) => {
                        this.setState({activeTabIndex: e.index}, () => {
                            saveStoredListFilter(this.state.purchaseOrderStatus, e.index);
                            if (e.index === 0) {
                                this.refreshDataTable();
                            } else {
                                this.loadPaymentDuesForMonth();
                            }
                        });
                    }}
                >
                    <TabPanel header="Invoice List">
                        {this.renderInvoiceListTab()}
                    </TabPanel>
                    <TabPanel header="Payments">
                        {this.state.hasInvoiceLicense
                            ? this.renderPaymentCalendar()
                            : <div className="text-muted">Invoice license required.</div>}
                    </TabPanel>
                </TabView>
            </div>
        );
    }

    renderInvoiceListTab() {
        return (
            <>
                <div className="settings-page__invoice-toolbar settings-page__invoice-toolbar--in-tab">
                    <div className="settings-page__invoice-toolbar-row">
                        <div className="settings-page__invoice-toolbar-primary">
                            <div className="settings-page__invoice-status-seg" role="group" aria-label="Invoice status">
                                {PURCHASE_ORDER_STATUS.map(element => {
                                    const active = this.state.purchaseOrderStatus === element.value;
                                    return (
                                        <button
                                            key={element.value}
                                            type="button"
                                            className={`settings-page__invoice-status-seg__btn${active ? ' is-active' : ''}`}
                                            aria-pressed={active}
                                            onClick={() => this.setPurchaseOrderStatus(element.value)}
                                        >
                                            {element.name}
                                        </button>
                                    );
                                })}
                            </div>

                            <span className="settings-page__invoice-toolbar-divider" aria-hidden="true"/>

                            <div className="settings-page__invoice-toolbar-actions">
                                <Button
                                    color="outline-primary"
                                    className="settings-page__btn--add settings-page__btn--manual-entry"
                                    onClick={() => this.addNew('MANUAL_ENTRY')}
                                >
                                    <i className="pi pi-plus" aria-hidden="true"/>
                                    <Translate contentKey="entity.action.add">Manual Entry</Translate>
                                </Button>
                                <Button
                                    color="outline-primary"
                                    className="settings-page__btn--add settings-page__btn--smart-invoice"
                                    onClick={() => this.addNew('UPLOAD')}
                                >
                                    <i className="pi pi-star" aria-hidden="true"/>
                                    <Translate contentKey="entity.action.add">Smart Invoice Processor</Translate>
                                </Button>
                                <Button
                                    color="outline-primary"
                                    className="settings-page__btn--add settings-page__btn--import-csv"
                                    onClick={() => this.addNew('CSV')}
                                >
                                    <i className="pi pi-file-excel" aria-hidden="true"/>
                                    <Translate contentKey="entity.action.add">Import CSV</Translate>
                                </Button>
                                {false &&  <Button
                                    color="outline-primary"
                                    className="settings-page__btn--add settings-page__btn--from-dn"
                                    onClick={this.openCreateFromDeliveryNoteDialog}
                                >
                                    <i className="pi pi-clone" aria-hidden="true"/>
                                    From Delivery Note
                                </Button>
                                }
                            </div>
                        </div>

                        <div className="settings-page__invoice-toolbar-secondary">
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--action settings-page__btn--telegram"
                                onClick={() => {
                                    if (this.state.hasInvoiceLicense) {
                                        this.purchaseOrderService.telegramRegister().then((response) => {
                                            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                                window.open(response.url, '_blank');
                                            }
                                        });
                                    } else {
                                        return toast.warn("You don't have an invoice license or your credit has run out.");
                                    }
                                }}
                            >
                                <i className="pi pi-comments" aria-hidden="true"/>
                                <Translate contentKey="entity.action.add">Connect Telegram</Translate>
                            </Button>
                        </div>
                    </div>
                </div>

                {this.state.hasInvoiceLicense &&
                    <div className="settings-page__table-wrap">
                        <DataTable
                            ref={(elem) => (this.refDataTable = elem)}
                            fields={(GeneralUtils.isMobile() ? PurchaseOrderMobileColumn.fields : PurchaseOrderColumn.fields)
                                .filter(field => {
                                    if (field.maxWidthVisible && window.innerWidth < field.maxWidthVisible) {
                                        return false;
                                    }
                                    if (field.paymentSummary && this.state.purchaseOrderStatus !== 'CLOSED') {
                                        return false;
                                    }
                                    return true;
                                })}
                            objectName={GeneralUtils.isMobile() ? PurchaseOrderMobileColumn.fields : PurchaseOrderColumn.fields}
                            dataURL={this.state.hasInvoiceLicense ? 'inventory/purchaseOrder/all' : null}
                            rows={20}
                            autoLoad={false}
                            selectionMode="single"
                            onDataSelect={this.onDataSelect}
                            loading={this.state.loading}
                        />
                    </div>
                }
                {this.renderCreateFromDeliveryNoteDialog()}
            </>
        );
    }

    openCreateFromDeliveryNoteDialog = () => {
        if (!this.state.hasInvoiceLicense) {
            return toast.warn(LICENSE_CREDIT_MESSAGE);
        }
        this.setState({
            displayCreateFromDnDialog: true,
            selectedDeliveryNoteId: null,
            createFromDnList: [],
            createFromDnLoading: true
        }, () => this.loadUnlinkedDeliveryNotes());
    };

    closeCreateFromDeliveryNoteDialog = () => {
        if (this.state.creatingFromDn) {
            return;
        }
        this.setState({
            displayCreateFromDnDialog: false,
            selectedDeliveryNoteId: null,
            createFromDnList: [],
            createFromDnLoading: false
        });
    };

    loadUnlinkedDeliveryNotes = () => {
        this.setState({createFromDnLoading: true});
        this.purchaseOrderService.findAvailableUnlinkedDeliveryNotes({
            filter: [],
            sort: [],
            pageNumber: 0,
            limit: 200
        }).then(result => {
            const rows = Array.isArray(result?.data) ? result.data : (Array.isArray(result) ? result : []);
            this.setState({
                createFromDnList: rows || [],
                createFromDnLoading: false
            });
        }).catch(() => this.setState({createFromDnList: [], createFromDnLoading: false}));
    };

    onCreateFromDnSelect = (row) => {
        if (!row?.id) {
            return;
        }
        this.setState({selectedDeliveryNoteId: row.id});
    };

    confirmCreateFromDeliveryNote = () => {
        if (!this.state.hasInvoiceLicense) {
            return toast.warn(LICENSE_CREDIT_MESSAGE);
        }
        const deliveryNoteId = this.state.selectedDeliveryNoteId;
        if (GeneralUtils.isNullOrEmpty(deliveryNoteId)) {
            return toast.warn('Please select a Delivery Note');
        }
        this.setState({creatingFromDn: true});
        this.purchaseOrderService.createFromDeliveryNote(deliveryNoteId).then(response => {
            this.setState({creatingFromDn: false});
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type) && response.id) {
                saveStoredListFilter(this.state.purchaseOrderStatus, this.state.activeTabIndex);
                setOpenDetailPaymentsTab(false);
                this.setState({displayCreateFromDnDialog: false});
                window.location.href = '#purchaseOrderSave?' + response.id + '?' + (response.invoiceType || 'MANUAL_ENTRY');
            }
        }).catch(() => this.setState({creatingFromDn: false}));
    };

    renderCreateFromDeliveryNoteDialog() {
        const list = this.state.createFromDnList || [];
        const loading = this.state.createFromDnLoading;
        const creating = this.state.creatingFromDn;
        const selectedId = this.state.selectedDeliveryNoteId;
        const hasSelection = !GeneralUtils.isNullOrEmpty(selectedId);
        return (
            <Dialog
                visible={this.state.displayCreateFromDnDialog === true}
                header="Create Invoice from Delivery Note"
                onHide={this.closeCreateFromDeliveryNoteDialog}
                style={{width: '720px', maxWidth: '96vw'}}
            >
                <div className="purchase-requisition-assign-po-dialog">
                    <p className="text-muted mb-2" style={{fontSize: '0.9rem'}}>
                        Select one closed Delivery Note. A new invoice will be created with the same items
                        and linked to that Delivery Note.
                    </p>
                    {loading
                        ? <div className="text-muted">Loading delivery notes…</div>
                        : list.length === 0
                            ? <div className="text-muted">No unlinked closed Delivery Notes available.</div>
                            : (
                                <div className="settings-page__table-wrap">
                                    <DataTable
                                        fields={INVOICE_FROM_DN_FIELDS}
                                        objectName="InvoiceFromDeliveryNote"
                                        data={list}
                                        rows={10}
                                        paginator={true}
                                        selectionMode="single"
                                        onDataSelect={this.onCreateFromDnSelect}
                                        loading={false}
                                    />
                                </div>
                            )
                    }
                    {hasSelection &&
                        <div className="mt-2" style={{fontSize: '0.9rem', fontWeight: 600}}>
                            Selected: {(list.find(r => Number(r.id) === Number(selectedId)) || {}).requisitionNo
                                || ('#' + selectedId)}
                        </div>
                    }
                    <div
                        className="settings-page__actions settings-page__actions--dialog-footer"
                        style={{marginTop: '0.75rem'}}
                    >
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--cancel"
                            onClick={this.closeCreateFromDeliveryNoteDialog}
                            disabled={creating}
                        >
                            Close
                        </Button>
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--save"
                            onClick={this.confirmCreateFromDeliveryNote}
                            disabled={!hasSelection || creating || loading}
                        >
                            {creating ? 'Creating…' : 'Create Invoice'}
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }

    renderPaymentCalendar() {
        const selectedDayKey = dayjs(this.state.selectedCalendarDay).format('YYYY-MM-DD');
        const duesForDay = (this.state.paymentDues || []).filter(item =>
            dayjs(item.paymentDueDate).format('YYYY-MM-DD') === selectedDayKey
        );
        const dueDaySet = new Set(
            (this.state.paymentDues || [])
                .map(item => dayjs(item.paymentDueDate).format('YYYY-MM-DD'))
                .filter(Boolean)
        );
        const todayKey = dayjs().format('YYYY-MM-DD');

        return (
            <div className="invoice-payment-calendar">
                <Row>
                    <Col md="5">
                        <Calendar
                            value={this.state.selectedCalendarDay}
                            inline
                            viewDate={this.state.calendarMonth}
                            onViewDateChange={(e) => {
                                this.setState({calendarMonth: e.value}, () => this.loadPaymentDuesForMonth());
                            }}
                            onChange={(e) => this.setState({selectedCalendarDay: e.value})}
                            dateTemplate={(dateMeta) => {
                                const key = dayjs(new Date(dateMeta.year, dateMeta.month, dateMeta.day)).format('YYYY-MM-DD');
                                const hasDue = dueDaySet.has(key);
                                let highlightClass = '';
                                if (hasDue) {
                                    if (key < todayKey) {
                                        highlightClass = 'invoice-payment-calendar__day--overdue';
                                    } else if (key === todayKey) {
                                        highlightClass = 'invoice-payment-calendar__day--due-today';
                                    } else {
                                        highlightClass = 'invoice-payment-calendar__day--upcoming';
                                    }
                                }
                                return (
                                    <span className={`invoice-payment-calendar__day${highlightClass ? ` ${highlightClass}` : ''}`}>
                                        {dateMeta.day}
                                    </span>
                                );
                            }}
                        />
                        <div className="invoice-payment-calendar__legend text-muted">
                            <span className="invoice-payment-calendar__legend-item">
                                <span className="invoice-payment-calendar__legend-swatch invoice-payment-calendar__day--overdue"/>
                                Overdue (past unpaid)
                            </span>
                            <span className="invoice-payment-calendar__legend-item">
                                <span className="invoice-payment-calendar__legend-swatch invoice-payment-calendar__day--due-today"/>
                                Due today
                            </span>
                            <span className="invoice-payment-calendar__legend-item">
                                <span className="invoice-payment-calendar__legend-swatch invoice-payment-calendar__day--upcoming"/>
                                Upcoming unpaid
                            </span>
                        </div>
                    </Col>
                    <Col md="7">
                        <h5 style={{marginBottom: 12}}>
                            Due on {dayjs(this.state.selectedCalendarDay).format('DD/MM/YYYY')}
                        </h5>
                        {this.state.paymentDuesLoading && <div>Loading…</div>}
                        {!this.state.paymentDuesLoading && duesForDay.length === 0 &&
                            <div className="text-muted">No upcoming payments on this day.</div>}
                        {!this.state.paymentDuesLoading && duesForDay.map(item => (
                            <div
                                key={item.id}
                                onClick={() => this.onDataSelect(item)}
                                style={{
                                    border: '1px solid #e5e7eb',
                                    borderRadius: 8,
                                    padding: '10px 12px',
                                    marginBottom: 8,
                                    cursor: 'pointer'
                                }}
                            >
                                <div style={{fontWeight: 600}}>
                                    {item.invoiceNumber || ('Invoice #' + item.id)} — {item.supplierName || '-'}
                                </div>
                                <div style={{fontSize: 13, color: '#4b5563'}}>
                                    Remaining £{Number(item.remainingAmount || 0).toFixed(2)}
                                    {' · '}
                                    {item.paymentStatus || 'UNPAID'}
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </div>
        );
    }

    loadPaymentDuesForMonth = () => {
        if (!this.state.hasInvoiceLicense) {
            return;
        }
        const month = dayjs(this.state.calendarMonth || new Date());
        const from = month.startOf('month').format('YYYY-MM-DD');
        const to = month.endOf('month').format('YYYY-MM-DD');
        this.setState({paymentDuesLoading: true});
        this.purchaseOrderService.findPaymentDues(from, to).then(response => {
            this.setState({
                paymentDuesLoading: false,
                paymentDues: Array.isArray(response) ? response : []
            });
        }).catch(() => this.setState({paymentDuesLoading: false, paymentDues: []}));
    };


    refreshDataTable = () => {
        if (!this.state.hasInvoiceLicense || !this.refDataTable) return;

        const { purchaseOrderStatus } = this.state;
        let value = purchaseOrderStatus;
        let type = "string";
        let filterMatchMode = "equals";

        if (purchaseOrderStatus === "INVOICE") {
            value = ["INVOICE", "PARTIAL_CLOSED"];
            type = "list";
            filterMatchMode = "in";
        }

        if (this.refDataTable.dt) {
            this.refDataTable.dt.filter(value, "purchaseOrderStatus", filterMatchMode);
        }

        this.refDataTable.onModelFilterChangeWithNameAndValue(
            "purchaseOrderStatus",
            value,
            type,
            null,
            filterMatchMode
        );
    };

    refreshDataTableSilent = () => {
        if (this.state.activeTabIndex === 1) {
            return;
        }
        if (!this.state.hasInvoiceLicense || !this.refDataTable) return;

        const { purchaseOrderStatus } = this.state;
        let value = purchaseOrderStatus;
        let type = "string";
        let filterMatchMode = "equals";

        if (purchaseOrderStatus === "INVOICE") {
            value = ["INVOICE", "PARTIAL_CLOSED"];
            type = "list";
            filterMatchMode = "in";
        }

        this.refDataTable.reloadWithCurrentState({
            purchaseOrderStatus: { value, type, filterMatchMode }
        });
    };


    onDataSelect = (data) => {
        if (this.state.hasInvoiceLicense) {
            saveStoredListFilter(this.state.purchaseOrderStatus, this.state.activeTabIndex);
            setOpenDetailPaymentsTab(this.state.activeTabIndex === 1);
            window.location.href = "#purchaseOrderSave?" + data.id + "?" + (data.invoiceType || '');
        } else {
            return toast.warn("You don't have an invoice license or your credit has run out.");

        }

    }

    addNew(invoiceType) {
        if (this.state.hasInvoiceLicense) {
            saveStoredListFilter(this.state.purchaseOrderStatus, this.state.activeTabIndex);
            setOpenDetailPaymentsTab(false);
            window.location.href = "#purchaseOrderSave?" + "-1" + "?" + invoiceType;
        } else {
            return toast.warn("You don't have an invoice license or your credit has run out.");

        }


    }

    setPurchaseOrderStatus = (value) => {
        if (value === this.state.purchaseOrderStatus) {
            return;
        }
        this.setState({purchaseOrderStatus: value}, () => {
            saveStoredListFilter(value, this.state.activeTabIndex);
            this.refreshDataTable();
        });
    };

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setPurchaseOrderStatus(value);
    }


}
